export type ContentNavigationIcon =
  | 'blog'
  | 'directory'
  | 'free-tools'
  | 'book'
  | 'ebook'
  | 'lead-magnet'
  | 'kdp'
  | 'coach'
  | 'consultant'
  | 'course'
  | 'agency'
  | 'author'
  | 'ideas'
  | 'marketplace'
  | 'course-free';


export type ContentNavigationItem = {
  name: string;
  href: string;
  description: string;
  icon: ContentNavigationIcon;
  badge?: string;
  emoji?: string;
};

export const contentNavigationGroups: { label: string; items: ContentNavigationItem[] }[] = [
  {
    label: 'Book marketing',
    items: [
      { name: 'Book Marketing Guide', href: '/book-marketing', description: 'Choose your reader and promotion strategy', icon: 'book' },
      { name: 'AI Book Marketing', href: '/book-marketing/ai-book-marketing', description: 'Turn book passages into captions and images', icon: 'book' },
      { name: 'Social Media for Authors', href: '/book-marketing/social-media-for-authors', description: 'Build a sustainable weekly content routine', icon: 'author' },
      { name: 'Self-Published Book Marketing', href: '/book-marketing/how-to-market-a-self-published-book', description: 'Prepare your listing and reader journey', icon: 'kdp' },
      { name: 'BookTok Marketing', href: '/book-marketing/booktok-marketing', description: 'Plan book-based TikTok videos', icon: 'author' },
      { name: 'Book Marketing Plan', href: '/book-marketing/book-marketing-plan', description: 'Copy a four-week campaign worksheet', icon: 'book' },
      { name: 'Book Launch Marketing Plan', href: '/book-marketing/book-launch-marketing-plan', description: 'Prepare a dated launch checklist', icon: 'book' },
      { name: 'Amazon KDP Marketing', href: '/book-marketing/amazon-kdp-marketing', description: 'Connect your listing with promotion', icon: 'kdp' },
      { name: 'Meta Ads for Books', href: '/book-marketing/meta-ads-for-books', description: 'Plan paid tests and realistic budgets', icon: 'author' },
    ],
  },
  {
    label: 'Marketing software comparisons',
    items: [
      { name: 'Bookstera vs Native', href: '/bookstera-vs-native', description: 'Compare book and business workflows', icon: 'directory' },
      { name: 'Native Alternatives', href: '/native-alternatives', description: 'Choose content, scheduling or team tools', icon: 'directory', badge: 'New' },
    ],
  },
  {
    label: 'Guides and editorial',
    items: [
      { name: 'Book Growth Hub', href: '/book-growth', description: 'Publish, promote and monetize finished books', icon: 'book' },
      { name: 'Self-Publisher Playbooks', href: '/self-publisher-playbooks', description: 'Step-by-step publishing and marketing guides', icon: 'kdp', badge: 'New' },
      { name: 'Bookstera Blog', href: '/blog', description: 'Publishing, funnels and authority-building', icon: 'blog' },
      { name: 'AI Tools Directory', href: '/tools', description: 'Find and compare tools for authors', icon: 'directory' },
      { name: 'Best Free Author Tools', href: '/tools/free', description: 'Useful tools with a genuine free option', icon: 'free-tools' },
      { name: 'AI Book Generator Guide', href: '/ai-book-generator', description: 'Plan, draft, edit and package a book', icon: 'book' },
      { name: 'Create an Ebook with AI', href: '/create-an-ebook-with-ai', description: 'A complete step-by-step workflow', icon: 'ebook' },
      { name: 'Lead Magnet Generator', href: '/lead-magnet-generator', description: 'Create the asset and funnel together', icon: 'lead-magnet' },
      { name: 'Amazon KDP and AI', href: '/amazon-kdp-ai', description: 'Quality, policy and publishing guidance', icon: 'kdp' },
    ],
  },
  {
    label: 'Use cases',
    items: [
      { name: 'For Coaches', href: '/for-coaches', description: 'Turn a method into a client funnel', icon: 'coach' },
      { name: 'For Consultants', href: '/for-consultants', description: 'Package expertise into lead assets', icon: 'consultant' },
      { name: 'For Course Creators', href: '/for-course-creators', description: 'Grow a list before launch', icon: 'course' },
      { name: 'For Agencies', href: '/for-agencies', description: 'Create client-ready book funnels', icon: 'agency' },
      { name: 'For Authors', href: '/for-authors', description: 'Write, publish and promote with AI', icon: 'author' },
    ],
  },
  {
    label: 'Create and discover',
    items: [
      { name: 'Book Idea Generator', href: '/profitable-book-idea-generator', description: 'Find a focused book direction', icon: 'ideas' },
      { name: 'Bookstera-o-Matic', href: '/bookstera-o-matic', description: 'Spin playful book ideas in one click', icon: 'ideas', emoji: '🎲' },
      { name: 'Ebook Marketplace', href: '/marketplace', description: 'Discover books from Bookstera authors', icon: 'marketplace' },
      { name: 'Free Lead Magnet Course', href: '/free-course', description: 'Build your first acquisition asset', icon: 'course-free' },
    ],
  },
];

export const contentNavigationItems = contentNavigationGroups.flatMap((group) => group.items);
